/**
 * Client-side team membership for tasks (mirrors server taskBelongsToTeam).
 * Used for teams overview counts: team assignee + any roster member assignee.
 */

export const getStoredTaskTeamIdStrings = (task) => {
  const set = new Set();
  if (task?.teamId) set.add(String(task.teamId));
  (task?.teamIds || []).forEach((id) => {
    if (id) set.add(String(id));
  });
  return set;
};

export const memberIdsFromSettingsTeam = (team) => {
  const ids = new Set();
  (team?.members || []).forEach((m) => {
    const id = String(m?._id || m?.id || m || "").trim();
    if (id) ids.add(id);
  });
  return ids;
};

export const memberIdsFromOverviewTeam = (overviewRow) => {
  const ids = new Set();
  (overviewRow?.memberIds || []).forEach((id) => {
    const s = String(id || "").trim();
    if (s) ids.add(s);
  });
  return ids;
};

export const buildTeamMemberIdsMap = (settingsTeams = [], teamsOverview = []) => {
  const map = new Map();
  (settingsTeams || []).forEach((team) => {
    const teamId = String(team?._id || team?.id || "").trim();
    if (!teamId) return;
    map.set(teamId, memberIdsFromSettingsTeam(team));
  });
  (teamsOverview || []).forEach((row) => {
    const teamId = String(row?.teamId || "").trim();
    if (!teamId) return;
    const fromOverview = memberIdsFromOverviewTeam(row);
    if (fromOverview.size) {
      const existing = map.get(teamId) || new Set();
      fromOverview.forEach((id) => existing.add(id));
      map.set(teamId, existing);
    }
  });
  return map;
};

/**
 * Whether a task belongs to a team (teamId/teamIds, team assignee, or member on roster).
 */
export const taskBelongsToTeam = (task, teamId, memberIds) => {
  if (!task || !teamId) return false;
  const tid = String(teamId);
  const storedTeams = getStoredTaskTeamIdStrings(task);
  if (storedTeams.has(tid)) return true;

  const roster =
    memberIds instanceof Set ? memberIds : new Set(memberIds || []);

  for (const p of task.assignees || []) {
    if (!p?.id) continue;
    const type = String(p.type || "").toLowerCase();
    const id = String(p.id);
    if (type === "team" && id === tid) return true;
    if (type === "teammember" && roster.has(id)) return true;
  }
  return false;
};
